import React from 'react';

const TwitterIcon = ({ width = '40', height = '40' }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    className="fill-current text-techsicoGray-200 hover:text-white hover:shadow-2xl"
  >
    <path
      d="M44.466,1.426H21.132A8.333,8.333,0,0,0,12.8,9.759V33.093a8.333,8.333,0,0,0,8.333,8.333H44.466A8.334,8.334,0,0,0,52.8,33.093V9.759A8.334,8.334,0,0,0,44.466,1.426Zm-.232,15.4A15.558,15.558,0,0,1,20.3,30.638a11.018,11.018,0,0,0,8.1-2.265,5.477,5.477,0,0,1-5.11-3.8,5.5,5.5,0,0,0,2.47-.1,5.474,5.474,0,0,1-4.387-5.433,5.438,5.438,0,0,0,2.477.685,5.479,5.479,0,0,1-1.693-7.305,15.534,15.534,0,0,0,11.277,5.717,5.474,5.474,0,0,1,9.322-4.99,10.972,10.972,0,0,0,3.477-1.327,5.5,5.5,0,0,1-2.4,3.027,10.964,10.964,0,0,0,3.142-.862A11.115,11.115,0,0,1,44.234,16.821Z"
      transform="translate(-12.799 -1.426)"
    />
  </svg>
);

export default TwitterIcon;
